import styled from '@emotion/styled';
import React, { ReactNode } from 'react'
import { theme } from '../../theme/maintheme';

type Iprops = {
  children: ReactNode | boolean | null
}

const FormComponent = styled("form")(({ theme: any }) => ({
  marginBottom: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  ".MuiBox-root": {
    "& .MuiFormLabel-root": {
      fontSize: "inherit",
    },
  
    "& .MuiFormControlLabel-label": {
      fontSize: "inherit",
    },
    "& strong": {
      margin: theme.spacing(1),
      marginLeft: 0,
      display: "inline-block",
    },

    "& .MuiFormControl-root": {
      fontSize: "inherit",
      
      "& .MuiBox-root": {
        margin: theme.spacing(1, 0, 0, 0),
  
        "& .MuiFormLabel-root": {
          fontSize: "inherit",
          width: "auto",
          margin: theme.spacing(0, 0.5, 0, 0),
        },
      },
  
      "& .MuiFormGroup-root": {
        "& label.MuiFormControlLabel-root": {
          marginBottom: theme.spacing(0),
  
          "& span.MuiRadio-root": {
            padding: theme.spacing(0.5),
            margin: theme.spacing(0, 0.5, 0, 1),
          },
  
          "& .MuiFormControlLabel-label": {
            color: "var(--kyocera-text-grey)",
            fontSize: "0.8rem",
          },
        },
      },
    },
  },


  "& .MuiTextField-root": {
    margin: theme.spacing(3, 0, 3, 0),
    display: "block",
    [theme.breakpoints.between("xs", "lg")]: {
      width: "100%",
    },
    [theme.breakpoints.up("lg")]: {
      width: 450,
    },
    "& .MuiInputBase-root": {
      width: "100%",
      "input": {
        paddingLeft: "6px",
        paddingRight: "6px",
      }
    },
    "& div.MuiOutlinedInput-root": {
      fontSize: "inherit",
      padding: theme.spacing(1),
      borderRadius: "8px",
      "& input.MuiOutlinedInput-input": {
        boxSizing: "border-box",
      },
    },
    "& p.MuiFormHelperText-root.MuiFormHelperText-contained": {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: -20,
      marginTop: 1,
    },
  },

  "& .MuiSelect-select": {
    display: "block",
    [theme.breakpoints.between("xs", "lg")]: {
      width: "100%",
    },
    [theme.breakpoints.up("lg")]: {
      width: 450,
    },
  }
    

}));

const FormStyling = (props: Iprops) => {
  const {children} = props
  return (
    <>
    <FormComponent onSubmit={(e) => {e.preventDefault()}} noValidate autoComplete="off" >
      {children}
    </FormComponent>
    </>
  )
}

export default FormStyling